class ClientEditFormController {
    constructor(CampusEditFormService, ClientEditService) {
        'ngInject';

        this.CampusEditFormService = CampusEditFormService;
        this.ClientEditFormService = ClientEditService;

    }

    $onInit() {
        this.isErrorVisible = false;
        this.errorMessage = '';
        this.showSaveSuccess = false;
        this.configureActiveServices();

        this.previousCampusName = this.campus.name;
        this.states = this.CampusEditFormService.getStates();
        this.cities = [];
        this.selectedCity = {
            id: this.campus.city,
            name: this.campus.city_name,
        };
        this.selectedState = {
            id: this.campus.state,
            name: this.campus.state_name,
        };
        this.cities = !!this.selectedState.id ? this.CampusEditFormService.getCities(this.selectedState.id) : [];

        // need to have users be able to select a "null" or empty choice
        // Start with active reasons from the API
        this.temporarilyClosedReasons = [{ id: '', name: 'None Set'}, ...this.relatedModels.CampusTemporaryClosedReason];
        
        // If the campus has a temp_closed_reason that's not in the active list (e.g., inactive COVID),
        // add it to the list so it can be displayed
        if (this.campus.temp_closed_reason) {
            // Handle both object format (from serializer) and ID format (legacy)
            const currentReason = typeof this.campus.temp_closed_reason === 'object' 
                ? this.campus.temp_closed_reason 
                : null;
            const currentReasonId = currentReason ? currentReason.id : this.campus.temp_closed_reason;
            
            if (currentReasonId) {
                // Convert to number for comparison (IDs might be strings or numbers)
                const reasonIdNum = typeof currentReasonId === 'string' ? parseInt(currentReasonId, 10) : currentReasonId;
                const isInList = this.temporarilyClosedReasons.some(reason => {
                    const reasonId = typeof reason.id === 'string' ? parseInt(reason.id, 10) : reason.id;
                    return reasonId === reasonIdNum;
                });
                
                if (!isInList) {
                    // Add the campus's current reason even if it's inactive
                    if (currentReason) {
                        this.temporarilyClosedReasons.push(currentReason);
                    } else {
                        // If we only have an ID, create a placeholder object
                        // This shouldn't happen with the new serializer, but handle it for safety
                        this.temporarilyClosedReasons.push({ id: currentReasonId, name: 'Unknown Reason' });
                    }
                }
            }
        }
        
        // select the reason that came back from the database
        let tempReasonId = null;
        if (this.campus.temp_closed_reason) {
            if (typeof this.campus.temp_closed_reason === 'object' && this.campus.temp_closed_reason.id) {
                tempReasonId = this.campus.temp_closed_reason.id;
            } else {
                tempReasonId = this.campus.temp_closed_reason;
            }
        }
        this.selectedTemporarilyClosedReason = this.getTemporarilyClosedReason(tempReasonId);


        // need to have users be able to select a "null" or empty choice
        // Start with active reasons from the API
        this.permanentlyClosedReasons = [{ id: '', name: 'None Set'}, ...this.relatedModels.CampusPermanentlyClosedReason];
        
        // If the campus has a perm_closed_reason that's not in the active list (e.g., inactive COVID),
        // add it to the list so it can be displayed
        if (this.campus.perm_closed_reason) {
            // Handle both object format (from serializer) and ID format (legacy)
            const currentReason = typeof this.campus.perm_closed_reason === 'object' 
                ? this.campus.perm_closed_reason 
                : null;
            const currentReasonId = currentReason ? currentReason.id : this.campus.perm_closed_reason;
            
            if (currentReasonId) {
                // Convert to number for comparison (IDs might be strings or numbers)
                const reasonIdNum = typeof currentReasonId === 'string' ? parseInt(currentReasonId, 10) : currentReasonId;
                const isInList = this.permanentlyClosedReasons.some(reason => {
                    const reasonId = typeof reason.id === 'string' ? parseInt(reason.id, 10) : reason.id;
                    return reasonId === reasonIdNum;
                });
                
                if (!isInList) {
                    // Add the campus's current reason even if it's inactive
                    if (currentReason) {
                        this.permanentlyClosedReasons.push(currentReason);
                    } else {
                        // If we only have an ID, create a placeholder object
                        // This shouldn't happen with the new serializer, but handle it for safety
                        this.permanentlyClosedReasons.push({ id: currentReasonId, name: 'Unknown Reason' });
                    }
                }
            }
        }
        
        // select the reason that came back from the database
        let permReasonId = null;
        if (this.campus.perm_closed_reason) {
            if (typeof this.campus.perm_closed_reason === 'object' && this.campus.perm_closed_reason.id) {
                permReasonId = this.campus.perm_closed_reason.id;
            } else {
                permReasonId = this.campus.perm_closed_reason;
            }
        }
        this.selectedPermanentlyClosedReason = this.getPermanentlyClosedReason(permReasonId);

    }

    hideError() {
        this.isErrorVisible = false;
        this.errorMessage = '';
    }

    /***
     * Grab the Temporarily Closed Reason whose ID is equal to the provided value.
     *
     * @param reasonIds     the IDs of the temporary reason being fetched.
     *
     * @returns {temp reason object}
     */
    getTemporarilyClosedReason(reasonId) {
        if (reasonId === null || reasonId === undefined || reasonId === '') {
            return this.temporarilyClosedReasons[0];
        }
        // Convert to number for comparison (IDs might be strings or numbers)
        const reasonIdNum = typeof reasonId === 'string' ? parseInt(reasonId, 10) : reasonId;
        return this.temporarilyClosedReasons.filter((g) => {
            const gId = typeof g.id === 'string' ? parseInt(g.id, 10) : g.id;
            return gId === reasonIdNum;
        }).pop() || this.temporarilyClosedReasons[0];
    }

    /***
     * Assigns the selected Temporarily Closed Reason to the display property as well as
     * assigning its ID to the current campus.
     *
     * @param item      a temp reason object
     */
    setTemporarilyClosedReason(item) {
        this.selectedTemporarilyClosedReason = item;
        this.campus.temp_closed_reason = item.id;
    }

    /***
     * Grab the Permanently Closed Reason whose ID is equal to the provided value.
     *
     * @param reasonIds     the IDs of the temporary reason being fetched.
     *
     * @returns {permanent reason object}
     */
    getPermanentlyClosedReason(reasonId) {
        if (reasonId === null || reasonId === undefined || reasonId === '') {
            return this.permanentlyClosedReasons[0];
        }
        // Convert to number for comparison (IDs might be strings or numbers)
        const reasonIdNum = typeof reasonId === 'string' ? parseInt(reasonId, 10) : reasonId;
        return this.permanentlyClosedReasons.filter((g) => {
            const gId = typeof g.id === 'string' ? parseInt(g.id, 10) : g.id;
            return gId === reasonIdNum;
        }).pop() || this.permanentlyClosedReasons[0];
    }

    /***
     * Assigns the selected Permanently Closed Reason to the display property as well as
     * assigning its ID to the current campus.
     *
     * @param item      a permanent reason object
     */
    setPermanentlyClosedReason(item) {
        this.selectedPermanentlyClosedReason = item;
        this.campus.perm_closed_reason = item.id;
    }


    /**
     * selectState
     *  Callback for the typehead component in the template used to select state/province
     *
     * @param item {object}
     */
    selectState(item) {
        this.selectedState = item;
        this.cities = this.CampusEditFormService.getCities(item.id);
    }

    /**
     * selectCity
     *  Callback for the typehead component in the template used to select city
     *
     * @param item {object}
     */
    selectCity(item) {
        this.selectedCity = item;
    }

    /***
     * Iterate through the services and use the campus's list of assigned service IDs to determine which should have
     * an isChecked booelan flag toggled on.
     */
    configureActiveServices() {
        for (let service of this.serviceList) {
            service.isChecked = this.campus.services.includes(service.id);
        }
    }

    saveCampusSettings() {
        this.showSaveSuccess = false;

        let data = {
            name: this.campus.name,
            services: this.serviceList.filter(s => s.isChecked).map(s => s.id),
            address_1: this.campus.address_1,
            address_2: this.campus.address_2,
            city: this.selectedCity.id,
            state: this.selectedState.id,
            postal_code: this.campus.postal_code,
        };
        
        // Handle reason IDs - convert empty strings to null, ensure valid IDs are numbers
        if (this.selectedTemporarilyClosedReason && this.selectedTemporarilyClosedReason.id !== '' && this.selectedTemporarilyClosedReason.id !== null && this.selectedTemporarilyClosedReason.id !== undefined) {
            data.temp_closed_reason_id = typeof this.selectedTemporarilyClosedReason.id === 'string' ? parseInt(this.selectedTemporarilyClosedReason.id, 10) : this.selectedTemporarilyClosedReason.id;
        } else {
            data.temp_closed_reason_id = null;
        }
        
        if (this.selectedPermanentlyClosedReason && this.selectedPermanentlyClosedReason.id !== '' && this.selectedPermanentlyClosedReason.id !== null && this.selectedPermanentlyClosedReason.id !== undefined) {
            data.perm_closed_reason_id = typeof this.selectedPermanentlyClosedReason.id === 'string' ? parseInt(this.selectedPermanentlyClosedReason.id, 10) : this.selectedPermanentlyClosedReason.id;
        } else {
            data.perm_closed_reason_id = null;
        }

        const booleanFields = ['is_fit_available', 'is_headquarters_location', 'is_physical_therapy_available', 'is_training_available'];
        for (let field of booleanFields) {
            if (this.campus.hasOwnProperty(field)) {
                data[field] = Boolean(this.campus[field]) ? 1 : 0;
            }
        }

        this.CampusEditFormService.updateCampus(this.campus.id, data).then(
            successResponse => {
                this.showSaveSuccess = true;
                if (this.previousCampusName !== this.campus.name) {
                    this.previousCampusName = this.campus.name;
                }
                this.updateTree();
            },
            errorResponse => {
                this.isErrorVisible = true;
                this.errorMessage = errorResponse.data;
            }
        );
    }
}

export default ClientEditFormController;



// WEBPACK FOOTER //
// ./app/components/client-edit/campus-edit-form/campus-edit-form-controller.js